<template>
  <v-checkbox
    v-model="roleIsSelected"
    @change="toggleAllRolePermissions"
    :label="$t('permissions.roles.' + roleName)"
    :ripple="false"
    :indeterminate="indeterminateState"
    :disabled="disabled"
    hide-details
    color="#4fa2b7"
    @click.stop=""
  />
</template>

<script>
export default {
  name: "RoleItem",

  props: {
    roleName: {
      type: String
    },

    permissionsSelected: {
      type: Array
    },

    disabled: {
      type: Boolean
    }
  },

  data() {
    return {
      roleIsSelected: false,
      rolePermissionsSelected: [],
      indeterminateState: false
    };
  },

  mounted() {
    this.updateRoleState();
  },

  computed: {
    role() {
      return this.$store.getters.getAllRolesAndPermissions.find(
        role => role.name === this.roleName
      );
    }
  },

  watch: {
    permissionsSelected() {
      this.updateRoleState();
    }
  },

  methods: {
    toggleAllRolePermissions() {
      let permissions = this.role.permissions;
      this.rolePermissionsSelected = [];
      if (this.roleIsSelected) {
        for (let i = 0; i < permissions.length; i++) {
          this.rolePermissionsSelected.push(permissions[i]["id"]);
        }
      }
      this.$emit("updatePermissions", this.rolePermissionsSelected);
    },

    updateRoleState() {
      if (this.role !== undefined && this.permissionsSelected !== undefined) {
        let imported = this.permissionsSelected.length;
        let local = this.role.permissions.length;
        if (imported === 0) {
          this.roleIsSelected = this.indeterminateState = false;
        } else if (imported > 0 && imported < local) {
          this.indeterminateState = true;
        } else if (imported === local) {
          this.roleIsSelected = true;
          this.indeterminateState = false;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/Accounts/Permissions/RoleItem.vue